import React from 'react';
import { useSectionControl } from '../contexts/SectionControlContext';
import { getSpacerHeight, SPACER_HEIGHT_VALUES, DEFAULT_SPACER_HEIGHT } from '../utils/sectionWidth';
import { useIsAdmin } from '../hooks/useIsAdmin';

/**
 * Spacer section — adds configurable vertical space between sections.
 * In admin/edit mode: shows a dashed border + faint label with the current height.
 * In player mode: renders an empty div with only the configured height.
 */
export default function SpacerSection({ sectionType, sections }) {
  const sectionControl = useSectionControl();
  const { isAdmin } = useIsAdmin();
  const section = sectionControl?.getSectionByType?.(sectionType);
  const heightKey = getSpacerHeight(section);
  const heightValue = SPACER_HEIGHT_VALUES[heightKey] || SPACER_HEIGHT_VALUES[DEFAULT_SPACER_HEIGHT];

  if (isAdmin) {
    return (
      <div
        className="w-full border-2 border-dashed border-orange-300/60 rounded-lg flex items-center justify-center"
        style={{ height: heightValue }}
      >
        <span className="text-orange-400/60 text-xs font-medium uppercase tracking-wider select-none">
          Spacer · {heightKey.toUpperCase()}
        </span>
      </div>
    );
  }

  return <div style={{ height: heightValue }} aria-hidden="true" />;
}
